import Axios from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  fetchRoadSpecialEventsFailure, fetchRoadSpecialEventsSuccess, saveRoadSpecialEventsFailure, saveRoadSpecialEventsSuccess
} from "../actions/specialEvents.action";
import * as selectors from './selector';


//worker functions
function* workerFetchRoadSpecialEvents(action) {
  try {
    const moment = require('moment');
    const access_token = yield select(selectors.access_token);

    const resp = yield call(
      Axios.get, `${process.env.REACT_APP_BASE_URL}/ivrapi` + `${process.env.REACT_APP_ROADS_EVENTS_URL_PATH}`, {
      headers: {
        Authorization: 'Bearer '+ access_token,
        transactionId: 'CCCRC.' + moment().unix(),
        requestTimeStamp: moment.utc().toJSON(),
      }
    });
    
    yield put(fetchRoadSpecialEventsSuccess(resp.data));
  } catch (e) {
    yield put(fetchRoadSpecialEventsFailure(e.message));
  }
}

function* workerSaveRoadSpecialEvents(action) {
  try {
    const moment = require('moment');
    const access_token = yield select(selectors.access_token);

    const resp = yield call(
      Axios.put, `${process.env.REACT_APP_BASE_URL}/ivrapi` + `${process.env.REACT_APP_ROADS_EVENTS_URL_PATH}`,
       { specialEvents: action.payload.specialEvents }, {
      headers: {
        Authorization: 'Bearer '+access_token,
        transactionId: 'RCE.SRC.' + moment().unix(),
        requestTimeStamp: moment.utc().toJSON(),
      }
    });
    yield put(saveRoadSpecialEventsSuccess());
  } catch (e) {
    yield put(saveRoadSpecialEventsFailure(e.message));
  }
}
//Watcher functions
export function* watchSaveRoadSpecialEvents() {
  yield takeLatest("SAVE_ROAD_SPECIAL_EVENTS_START", workerSaveRoadSpecialEvents);
}
export function* watchFetchRoadSpecialEvents() {
  yield takeLatest("FETCH_ROAD_SPECIAL_EVENTS_START", workerFetchRoadSpecialEvents);
}

